import notify from "devextreme/ui/notify";

export const createError = (msg) => ({
  errors: [
    {
      target: null,
      message: msg || "Не удалось выполнить запрос"
    }
  ]
});

export const logError = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "error"
  );

export const logSuccess = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "success"
  );

export default {createError, logError, logSuccess}
